/*
 * Copyright (C) 2024 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, Input } from '@angular/core';
import { SimpleChartData } from '@app/app/shared/components/carts/SimpleChartData';

@Component({
  selector: 'ptl-simple-bar-chart',
  templateUrl: './simple-bar-chart.component.html',
  styleUrls: ['./simple-bar-chart.component.scss'],
})
export class SimpleBarChartComponent {
  @Input() chartData: SimpleChartData[];

  /** `v3` draws the chart in the v3 report's palette. Everywhere else it stays as it was. */
  @Input() variant: 'legacy' | 'v3' = 'legacy';
}
